{
    "Accessibility menu": "قائمة إمكانية الوصول",
    "Close": "إغلاق",
    "Content adjustments": "تعديلات المحتوى",
    "Navigation adjustments": "تعديلات التنقل",
    "Text Align": "Text Align",
    "Align Left": "محاذاة لليسار",
    "Align Center": "Align Center",
    "Align Right": "Align Right",
    "Adjust Font Size": "ضبط حجم الخط",
    "Highlight Title": "تمييز العنوان",
    "Highlight Links": "تمييز الروابط",
    "Readable Font": "خط مقروء",
    "Colour adjustments": "تعديلات الألوان",
    "Dark Contrast": "تباين داكن",
    "Light Contrast": "تباين فاتح",
    "High Contrast": "تباين عالي",
    "High Saturation": "تشبع عالي",
    "Low Saturation": "تشبع منخفض",
    "Monochrome": "أحادي اللون",
    "Tools": "الأدوات",
    "Reading Guide": "دليل القراءة",
    "Big Cursor": "مؤشر كبير",
    "Increase Font Size": "زيادة حجم الخط",
    "Decrease Font Size": "تقليل حجم الخط",
    "Letter Spacing": "المسافة بين الحروف",
    "Line Height": "ارتفاع السطر",
    "Font Weight": "سمك الخط",
    "Dyslexia Font": "خط عسر القراءة",
    "Language": "اللغة",
    "Accessibility widget": "فتح قائمة إمكانية الوصول",
    "Accessibility Profiles": "ملفات إمكانية الوصول",
    "Cognitive Disability": "الإعاقة المعرفية",
    "Seizure Safe": "آمن من النوبات",
    "Accessibility statement": "بيان إمكانية الوصول",
    "ADHD": "ADHD",
    "Low Vision": "Low Vision",
    "Pause Animations": "إيقاف الرسوم المتحركة",
    "Animation paused": "تم إيقاف الحركة مؤقتًا",
    "Reset all settings": "إعادة تعيين الإعدادات",
    "Shortcut:": "Shortcut:",
    "Epilepsy Safe Mode": "Epilepsy Safe Mode",
    "Mute sounds": "Mute sounds",
    "Page read": "Page read",
    "Page read controls": "Page read controls",
    "Pause": "Pause",
    "Resume": "Resume",
    "Stop": "Stop",
    "Settings": "Settings",
    "Speed": "Speed",
    "Voice": "Voice"
}
